module.exports = __webpack_public_path__ + "img/26_167.1d51f958.png";